<template>
  <fragment>
    <v-navigation-drawer
      v-if="isMobile"
      v-model="openDrawer"
      fixed
      temporary
      class="mobile-nav"
    >
      <mobile-menu :open="openDrawer" />
    </v-navigation-drawer>
    <v-app-bar
      v-scroll="handleScroll"
      id="header"
      style="z-index:91;"
      :class="{
        fixed: fixed,
        'open-drawer': openDrawer,
        invert: invert,
        noHeader: sticky ? '' : 'no-header'
      }"
      class="header"
      fixed
      app
    >
      <v-container :class="{ 'fixed-width': isDesktop }">
        <div class="header-content">
          <nav
            :class="{ invert: invert }"
            class="nav-logo nav-menu"
          >
            <v-btn
              v-if="isMobile"
              :class="{ 'is-active': openDrawer }"
              class="hamburger hamburger--spin mobile-menu"
              text
              icon
              @click.stop="handleToggleOpen"
            >
              <span class="hamburger-box">
                <span class="bar hamburger-inner" />
              </span>
            </v-btn>
            <div class="logo">
              <nuxt-link
                v-if="invert"
                :to="link.movie.home"
              >
                <img
                  :src="logo"
                  alt="logo"
                >
              </nuxt-link>
              <div
                v-if="!invert && loaded"
                tag="span"
              >
                <a
                  href="/"
                  class="anchor-link scrollactive-item"
                >
                  <img
                    :src="logo"
                    alt="logo"
                  >
                </a>
              </div>
            </div>
            <div v-if="isDesktop">
              <!--
              <scrollactive
                :offset="navOffset"
                active-class="active"
                tag="ul"
              >
              -->
              <ul
                :class="sticky ? 'scrollactive-nav' : 'scrollactive-nav scrollactive-nav-no-header'"
                active-class="active"
              >

                <template v-for="(page, index) in menuPages">
                  <li v-if="page.show_in_menu == 1">
                    <v-btn
                      :href="`/`+ (menuPages.length === 1 ? '' : page.slug)"
                      class="anchor-link scrollactive-item"
                      text
                    >
                      {{ page.title }}
                    </v-btn>
                  </li>
                </template>
              </ul>
              <!--</scrollactive>-->
              <!--
              <scrollactive
                v-if="loaded"
                :offset="navOffset"
                active-class="active"
                tag="ul"
              >
                <li
                  v-for="(item, index) in menuList"
                  :key="index"
                >
                  <v-btn
                    v-if="!invert"
                    :href="item.url"
                    class="anchor-link scrollactive-item"
                    text
                    @click="setOffset(item.offset)"
                  >
                    item.name
                  </v-btn>
                  <v-btn
                    v-if="invert"
                    :href="'/' + item.url"
                    text
                  >
                    {{ item.name }}
                  </v-btn>
                </li>
              </scrollactive>
              -->
            </div>
          </nav>
          <!--
          <hidden point="mdDown">
            <span class="divider" />
          </hidden>

          <nav
            :class="{ invert: invert }"
            class="nav-menu nav-auth"
          >
            <hidden point="xsDown">
              <v-btn :href="link.movie.login" class="text-btn" text>
                Login
              </v-btn>
              <v-btn :href="link.movie.register" class="button">
                Register
              </v-btn>
            </hidden>
            <setting-menu :invert="invert" />
          </nav>
          -->
        </div>
      </v-container>
    </v-app-bar>
  </fragment>
</template>

<style lang="scss" scoped>
@import './header-style.scss';
</style>

<script>
import logo from '../../static/images/logo.png'
import link from '../../static/text/link'
import brand from '../../static/text/brand'
import Hidden from '../Hidden'
import navMenu from './menu'
import Settings from './Settings'
import MobileMenu from './MobileMenu'
//import FremcastMenu from '@fremcast/section/Menu';
import page from '@fremcast/section/mixins/page';

let counter = 0
function createData(name, url, offset) {
  counter += 1
  return {
    id: counter,
    name,
    url,
    offset
  }
}

export default {
  //extends: FremcastMenu,
  components: {
    'setting-menu': Settings,
    Hidden,
    MobileMenu
  },
  props: {
    invert: {
      type: Boolean,
      default: false
    },
    sticky: {
      type: Boolean,
      default: true
    },
    menuPages: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      logo: logo,
      link: link,
      loaded: false,
      brand: brand,
      section: 0,
      fixed: false,
      openDrawer: null,
      navOffset: 20,
      menuList: [
        createData(navMenu[0], '#' + navMenu[0], 100),
        createData(navMenu[1], '#' + navMenu[1]),
        createData(navMenu[2], '#' + navMenu[2]),
        createData(navMenu[3], '#' + navMenu[3]),
        createData(navMenu[4], '#' + navMenu[4])
      ]
    }
  },
  mounted() {
    this.loaded = true;
  },
  methods: {
    handleScroll: function() {
      if (window.scrollY > 80) {
        return (this.fixed = true)
      }
      return (this.fixed = false)
    },
    setOffset: function(offset) {
      this.navOffset = offset
    },
    handleToggleOpen: function() {
      this.openDrawer = !this.openDrawer
    }
  },
  computed: {
    isMobile() {
      const mdDown = ['mdDown', 'smDown', 'xsDown']
      return mdDown.indexOf(this.$mq) > -1
    },
    isDesktop() {
      const lgUp = ['lgDown', 'xl']
      return lgUp.indexOf(this.$mq) > -1
    }
  }
}
</script>
